import { useParams } from 'react-router-dom';
import EventsPage from '../EventsPage';

export function UsageTab() {
  const { orgId } = useParams<{ orgId: string }>();
  return <EventsPage initialOrgId={orgId} />;
}
